(function () {
    'use strict';

    angular
        .module('app.core')
        .config(config)

    var
        extend = angular.extend,
        forEach = angular.forEach,
        pop = Array.prototype.pop;

    config.$inject = ['$provide', '$resourceProvider'];
    function config($provide, $resourceProvider) {
        var defaultActions = $resourceProvider.defaults.actions;
        $resourceProvider.defaults.cancellable = true;

        $provide.decorator('$resource', resourceDecorator);

        resourceDecorator.$inject = ['$delegate'];
        function resourceDecorator($delegate) {
            return resourceProxy;

            function resourceProxy(url, paramDefaults, actions, options) {
                var resource,
                    proxyResource;

                proxyResource = createProxyResource(url, paramDefaults, actions, options);
                resource = $delegate.apply(this, arguments);
                forEach(resource, proxify);
                return resource;

                function proxify(value, key) {
                    resource[key] = function proxy() {
                        var showLoadingPanel = arguments[arguments.length - 1],
                            method = value;

                        if (typeof (showLoadingPanel) == 'boolean') {
                            pop.apply(arguments);
                            if (showLoadingPanel)
                                method = proxyResource[key];
                        }
                        return method.apply(this, arguments);
                    };
                }

                function createProxyResource(url, paramDefaults, actions, options) {
                    actions = extend({}, defaultActions, actions);
                    forEach(actions, function (value, key) {
                        actions[key] = extend({ showLoading: true }, value);
                    });
                    return $delegate.call(this, url, paramDefaults, actions, options);
                }
            }
        }
    }
})();